import useSWR from "swr";
import { API } from "../utils/constants";
import { fetcher } from "./fetcher";

/**
 * useEvents — Fetches upcoming public events sorted by eventDate ascending.
 *
 * API: GET /api/events → EventDto[] (CON-002 §4)
 * Defaults to fromDate = today (backend default).
 *
 * @returns {{ events: Array, error: any, isLoading: boolean }}
 */
export function useEvents() {
  const { data, error, isLoading } = useSWR(
    API.EVENTS.LIST,
    fetcher,
    { dedupingInterval: 60_000, revalidateOnFocus: false }
  );

  return { events: data ?? [], error, isLoading };
}

/**
 * useEvent — Fetches a single event by ID.
 *
 * API: GET /api/events/{id} → EventDto (CON-002 §4)
 *
 * @param {number|string|null} id
 * @returns {{ event: object|null, error: any, isLoading: boolean }}
 */
export function useEvent(id) {
  const { data, error, isLoading } = useSWR(
    id ? API.EVENTS.DETAIL(id) : null,
    fetcher,
    { revalidateOnFocus: false }
  );

  return { event: data ?? null, error, isLoading };
}
